/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useEffect } from "react";
import { Card, CardBody, Col, Row, Button, Spinner } from "reactstrap";
import DataTable from "../../../../shared/components/DataTable";
import { connect } from "react-redux";
import CardStatementSearchForm from "./CardStatementSearchForm";
import {
  searchCardStatement,
  downloadCardStatement,
  resetStatements,
  resetStatementDownload
} from "../../actions/cardStatements.actions";
import { MdFileDownload } from "react-icons/md";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import AccessControl from "../../../../shared/components/AccessControl";

const CardStatementTable = memo(
  ({ permissions, dispatch, cardStatement, cardStatementDownload }) => {
    useEffect(() => {
      return () => {
        dispatch(resetStatements());
        dispatch(resetStatementDownload());
      };
    }, [dispatch]);

    const count =
      cardStatement && cardStatement.response && cardStatement.response.data
        ? cardStatement.response.data.length
        : 0;

    const cardStatementData =
      cardStatement && cardStatement.response
        ? cardStatement.response.data
        : [];

    const columns = [
      {
        accessor: "tranTypeDescription",
        name: "Description",
        sortable: true,
        filterable: true,
        sortKey: "tranTypeDescription"
      },
      {
        accessor: "cardAcceptorNameLocation",
        name: "Location",
        sortable: true,
        filterable: true,
        sortKey: "cardAcceptorNameLocation",
        Cell: row => (
          <span>
            {row.cardAcceptorNameLocation.replace(/\s+/g, " ").trim()}
          </span>
        )
      },
      {
        accessor: "tranAmount",
        name: "Transaction Amount",
        sortable: true,
        sortKey: "tranAmount"
      },
      {
        accessor: "tranLocalDatetime",
        name: "Transaction Date/Time",
        sortable: true,
        sortKey: "tranLocalDatetime"
      },
      {
        accessor: "tranPostedDatetime",
        name: "Posted Date/Time",
        sortable: true,
        sortKey: "tranPostedDatetime"
      }
    ];

    const getCardStatement = values => {
      dispatch(searchCardStatement(values));
    };

    const handleDownload = () => {
      dispatch(
        downloadCardStatement({ ...cardStatement.request, download: true })
      );
    };

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">Search card statement</h5>
            </div>
            <CardStatementSearchForm
              loading={cardStatement && cardStatement.loading}
              onSubmit={getCardStatement}
            />
            {cardStatementData && cardStatementData.length ? (
              <AccessControl
                allowedPermissions={[
                  permissionsConstants.DOWNLOAD_CARD_STATEMENT
                ]}
                renderNoAccess={() => null}
              >
                <Row className="text-right">
                  <Col>
                    <Button
                      onClick={handleDownload}
                      disabled={cardStatementDownload.loading}
                      color="success"
                    >
                      {cardStatementDownload.loading ? (
                        <span className="mr-3">
                          <Spinner size="sm" color="default" />
                        </span>
                      ) : (
                        <MdFileDownload />
                      )}
                      Download
                    </Button>
                  </Col>
                </Row>
              </AccessControl>
            ): null}

            <DataTable
              columns={columns}
              loading={cardStatement && cardStatement.loading}
              data={cardStatementData}
              permissions={permissions}
              NoDataText={
                cardStatement && cardStatement.response
                  ? "No transaction(s) found"
                  : "Please enter search criteria"
              }
              count={count}
              countName="transactions"
              defaultPageSize={10}
              defaultPageNumber={1}
              error={cardStatement && cardStatement.error}
              bordered={true}
              striped={true}
              hover={true}
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
);

export default connect(state => ({
  cardStatement: state.cardStatement,
  cardStatementDownload: state.downloadCardStatement,
  permissions: state.permissions && state.permissions.response
}))(CardStatementTable);